import service1 from "../../Images/services-normal-1.png";
import service2 from "../../Images/services-normal-2.png";
import service3 from "../../Images/services-normal-3.png";
import service4 from "../../Images/services-normal-4.png"
import service5 from "../../Images/services-normal-5.png"
import service6 from "../../Images/services-normal-6.png"


export const ServiceData = [
  {
    id : 1,
    name: "Solar Eco-Power",
    img: service1,
    para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. it is Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
    className : "services-col"
  },
  {
    id : 2,
    name : "Wind Turbines Services",
    img : service2 ,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. it is Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
    className : "services-col wind-col"
  },
  {
    id : 3,
    name : "Htdropower Plants",
    img : service3 ,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. it is Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
    className : "services-col htdropower-col"
  },
  {
    id : 4,
    name: "Fossil Resources",
    img: service4,
    para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. it is Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
    className : "services-col fossil-col"
  },
  {
    id : 5,
    name : "Battery Materials",
    img : service5 ,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. it is Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
    className : "services-col battery-col"
  },
  {
    id : 6,
    name : "Charge Controllers",
    img : service6 ,
    para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. it is Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
    className : "services-col charge-co"
  },

];
